// components/ExcelUploader.jsx
import React, { useState } from "react";
import * as XLSX from "xlsx";

const ExcelUploader = ({ onDataLoaded, requiredColumns = [] }) => {
  const [fileName, setFileName] = useState(null);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    setFileName(file.name);
    setError(""); // Limpia errores previos

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const jsonData = XLSX.utils.sheet_to_json(ws, { defval: "" });

      // Validación de columnas requeridas
      const fileColumns = Object.keys(jsonData[0] || {});
      const missingColumns = requiredColumns.filter(
        (col) => !fileColumns.includes(col)
      );

      if (missingColumns.length > 0) {
        setError(
          `Faltan columnas requeridas: ${missingColumns.join(", ")}`
        );
        setData([]);
        return;
      }

      setData(jsonData);
      if (onDataLoaded) onDataLoaded(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  return (
    <div className="p-4 border rounded-md shadow-md bg-white">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Selecciona un archivo Excel:
      </label>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        className="mb-4"
      />
      {fileName && <p className="text-sm text-gray-600">Archivo: {fileName}</p>}
      {error && <p className="text-red-500 mt-2">{error}</p>}

      {data.length > 0 && (
        <div className="overflow-x-auto max-h-96 border mt-4">
          <table className="min-w-full text-sm text-left border">
            <thead className="bg-gray-100 sticky top-0">
              <tr>
                {Object.keys(data[0]).map((key) => (
                  <th key={key} className="px-3 py-2 border">
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx}>
                  {Object.values(row).map((cell, i) => (
                    <td key={i} className="px-3 py-2 border">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ExcelUploader;
